
export default {
  name: 'InfoContainer',
  components: {
  },
  props: {
    titleText: {
      type: String,
      default: ''
    },
    useSlot: {
      type: Boolean,
      default: false
    },
  },
}
